import dayjs from 'dayjs'
import 'dayjs/locale/zh-tw'
import utc from 'dayjs/plugin/utc'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.locale('zh-tw')

dayjs.extend(utc)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

export default {
  /**
   * Vue
   * @param {Vue} Vue
   */
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $dayjs: {
        get() {
          return dayjs
        }
      },
      $date: {
        get() {
          return dayjs
        }
      }
    })
    Vue.dayjs = dayjs
  }
}
